// extracted by mini-css-extract-plugin
export default {"link":"hotelCardExploreButton-module__link__JEYmc","button":"hotelCardExploreButton-module__button__m9yJp"};